/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "printifyapi",
            "endpoint": "https://mt6zq9oubl.execute-api.us-east-1.amazonaws.com/wiprod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:e74d5fa4-82ae-456d-bc27-f5360b557dd8",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_rhvafLPVj",
    "aws_user_pools_web_client_id": "21239tgch9dndt4aqv9t7j8na",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ProductMetadata-wiprod",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "printifyappb0bdd01d3ef64fca9f67d67b21b5a0883847d-wiprod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
